import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import { ManageCategory, showMessage } from "../../Functionalities/Functions";
import AddProduct from "../Products/AddProduct";
import EditTopComponent from '../../CoreComponents/EditTopComponent'
import EditBottomComponent from '../../CoreComponents/EditBottomComponent'
import NoDataComponent from "../../CoreComponents/NoDataComponent";
import ImageUploadWithCrop from "../../CoreComponents/ImageUploadWithCrop";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import LoadingComponent from "../../CoreComponents/LoadingComponent";



function Body(props) {
  const [data, setData] = useState({
    id: "",
    name: "",
    bg_image: "",
    icon: "",
    is_active: "",
    is_blocked: false,
    inner_category: ""
  });
  const [Edit, setEdit] = useState(false);
  const [noCat, setNoCat] = useState(false)
  const [loading, setloading] = useState(true)



  // void 0
  useEffect(() => {
    let id = props.id;
    // void 0
    let Catdata = ManageCategory("", "", "get", `id=${id}`);
    Catdata.then((cat) => {
      if (cat.data.results.length) {
        setData({
          ...data,
          id: cat.data.results[0].id,
          name: cat.data.results[0].name,
          bg_image:
            cat.data.results[0].bg_image && cat.data.results[0].bg_image.image,
          icon: cat.data.results[0].icon && cat.data.results[0].icon.image,
          is_active: cat.data.results[0].is_active,
          is_blocked: cat.data.results[0].is_blocked,
          inner_category: cat.data.results[0].inner_category,
        });
        setloading(false)
      }
      else {
        setNoCat(true)
        setloading(false)
      }

      // void 0
    });
  }, []);


  // const imageChange = (e) => {
  //     const reader = new FileReader();
  //     reader.addEventListener("load", () => {
  //         setData({ ...data, backgroundimage: reader.result });

  //     })
  //     reader.readAsDataURL(e.target.files[0]);
  // }
  // const imageChange1 = (e) => {
  //     const reader = new FileReader();
  //     reader.addEventListener("load", () => {
  //         setData({ ...data, icon: reader.result });

  //     })
  //     reader.readAsDataURL(e.target.files[0]);
  // }
  const submitHandler = (e) => {
    e.preventDefault();
    // void 0
  };

  const [errors, setErrors] = useState([]);

  useEffect(() => {
    if (errors.length > 0) {
      showMessage(
        errors[0],
        "danger",
        "Following fields required!",
        "top",
        "top-right",
        0
      );
    }
  }, [errors]);

  return (


    <div class="content-body">
      <div class="container-fluid">
        {
          !loading ?
            <>
              {
                !noCat ?
                  <>
                    <EditTopComponent
                      BackButtonPath={"/categories/"}
                      DeleteButton={(e) => {
                        e.preventDefault();
                        // if (window.confirm("Are You sure")) {
                        //   let res = ManageCategory(
                        //     e,
                        //     data,
                        //     "delete",
                        //     `id=${data.id}`
                        //   );
                        //   res.then((res) => {
                        //     if (res) {
                        //       alert("Success");
                        //       window.location.replace("/categories");
                        //     } else {
                        //       alert("Error");
                        //     }
                        //   });

                        // }
                        confirmAlert({
                          customUI: ({ onClose }) => {
                            return (
                              <div className='custom-ui' style={{ borderRadius: 8, border: 'solid', padding: 70, borderWidth: 0.5 }}>
                                <h1>Are you sure?</h1>
                                <p>You want to delete ?</p>
                                <button onClick={onClose} className="btn btn-primary" style={{ marginRight: 10, }}>Cancel</button>
                                <button

                                  onClick={() => {
                                    let res = ManageCategory(
                                      e,
                                      data,
                                      "delete",
                                      `id=${data.id}`
                                    );
                                    res.then((res) => {
                                      if (res) {
                                        showMessage("Delete success", "success", "Success!", "top", "top-right")
                                        window.location.replace("/categories");
                                      } else {
                                        showMessage("delete failed", "danger", "Failed!", "top", "top-right")
                                      }
                                    }).catch(err => {
                                      showMessage(res.data.Error, "danger", "Error!", "top", "top-right")
                                    })


                                  }}
                                  className="btn btn-primary"
                                >
                                  Delete
                            </button>
                              </div>
                            );
                          }
                        });

                      }}
                      AddButtonName={"Add Category"}
                      AddButtonPath={"/addCategory"}
                      CancelButton={(e) => {
                        e.preventDefault();
                        setEdit(false);
                        // void 0
                      }}
                      EditButton={
                        (e) => {
                          e.preventDefault();
                          setEdit(true);
                          // void 0
                        }
                      }
                      Edit={Edit}
                    />
                    <div className="col-xl-12 col-lg-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="basic-form">
                            <form>
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">
                                  Category Name{" "}
                                  <span className="required">*</span>
                                </label>
                                <div className="col-sm-9">
                                  {!Edit ?
                                    <label className="col-sm-3 col-form-label">
                                      {data.name}
                                    </label>
                                    :
                                    <input
                                      type="text"
                                      className="form-control"
                                      // readOnly={Edit}
                                      disabled={!Edit}
                                      value={data.name}
                                      onChange={(e) =>
                                        setData({ ...data, name: e.target.value })
                                      }
                                    />
                                  }
                                </div>
                              </div>

                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Active</label>

                                <div className="col-sm-2 ">
                                  <div className="custom-control custom-checkbox mb-3">
                                    <input
                                      type="checkbox"
                                      checked={data.is_active}
                                      value={data.is_active}
                                      disabled={!Edit}
                                      onClick={(e) =>
                                        setData({ ...data, is_active: e.target.checked })
                                      }
                                      className="custom-control-input"
                                      id="customCheckBox1"
                                    />
                                    <label
                                      className="custom-control-label"
                                      htmlFor="customCheckBox1"
                                    >
                                      Active
                          </label>
                                  </div>
                                </div>
                              </div>


                              {/* <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Is Menu</label>

                                <div className="col-sm-2 ">
                                  <div className="custom-control custom-checkbox mb-3">
                                    <input
                                      type="checkbox"
                                      checked={data.inner_category}
                                      value={data.inner_category}
                                      disabled={!Edit}
                                      onClick={(e) =>
                                        setData({ ...data, inner_category: e.target.checked })
                                      }
                                      className="custom-control-input"
                                      id="customCheckBox2"
                                    />
                                    <label
                                      className="custom-control-label"
                                      htmlFor="customCheckBox2"
                                    >
                                      Active
                          </label>
                                  </div>
                                </div>
                              </div> */}





                              {!Edit ? (
                                <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">Icon {" "}<span className="required">*</span></label>
                                  <div className="col-sm-9">
                                    <img
                                      className="img-fluid rounded mr-3"
                                      width={85}
                                      src={data.icon}
                                      alt="Foodoor"
                                    />
                                  </div>
                                </div>
                              )
                                :
                                (
                                  <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Icon <span className="required">*</span></label>
                                    {/* <span className="input-group-text">Upload</span> */}

                                    <div className="col-sm-9">
                                      <ImageUploadWithCrop
                                        value={data.icon}
                                        onChange={(file) =>
                                          setData({ ...data, icon: file })
                                        }
                                        aspectRatio={1}
                                        compress={false}
                                      />
                                    </div>
                                  </div>
                                )}


                              {Edit && (
                                <EditBottomComponent
                                  cancelButton={(e) => {
                                    e.preventDefault();
                                    setEdit(false);
                                    // void 0
                                  }}
                                  saveButton={(e) => {
                                    e.preventDefault();

                                    setErrors([]);
                                    if (data.name === "") {
                                      setErrors(["Category name"]);
                                      return;
                                    }
                                    // void 0

                                    let res = ManageCategory(e, data, "update");
                                    res.then((res) => {
                                      // void 0

                                      if (res.data.Status === true) {
                                        showMessage(
                                          "Category updated",
                                          "success",
                                          "Success!",
                                          "top",
                                          "top-right",
                                          0
                                        );
                                        setEdit(true);
                                      } else {
                                        showMessage(res.data.Error, "danger", "Failed!", "top", "top-right", 0);
                                      }
                                    });
                                  }}
                                />
                              )}
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                  :
                  <NoDataComponent data="Category" />}
            </>
            :

            <LoadingComponent />
        }
      </div>
    </div>


  );
}

function CategoryID() {


  const { id } = useParams();
  // void 0
  const headers = "Category Details";
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={headers} />
        <NavBar />
        {/* <Body bo={boln} na={name} nu={num} ar={ary} ob={obj} ao={aryobj} /> */}
        <Body id={id} />
        <Footer />
      </div>
    </div>
  );
}

export default CategoryID;
